import * as Notifications from "expo-notifications";
import { useCallback } from "react";
import { PushNotificationDeviceTypeEnum } from "../../apiTypes";
import { isAndroid, isWeb } from "../constants";
import { getPushNotificationToken } from "../helpers/tokens";
import { useAttachDeviceToUserMutation } from "../queries/User.generated";

Notifications.setNotificationHandler({
  handleNotification: async () => ({
    shouldShowAlert: true,
    shouldPlaySound: true,
    shouldSetBadge: true,
    shouldShowBanner: true,
    shouldShowList: true,
  }),
});

let savedExpoToken = "";

export function getSavedExpoToken() {
  return savedExpoToken;
}

export async function checkAndRequestNotificationPermissions() {
  const { status: currentStatus } = await Notifications.getPermissionsAsync();
  let permissionStatus = currentStatus;

  if (permissionStatus !== "granted") {
    const { status } = await Notifications.requestPermissionsAsync();
    permissionStatus = status;
  }

  return permissionStatus === "granted";
}

export const useSendExpoToken = () => {
  const [attachDeviceToUser] = useAttachDeviceToUserMutation();

  const sendExpoToken = useCallback(async () => {
    if (isWeb) return;

    const expoToken = await getPushNotificationToken();

    if (expoToken) {
      savedExpoToken = expoToken;
      attachDeviceToUser({
        variables: {
          data: {
            deviceType: isAndroid
              ? PushNotificationDeviceTypeEnum.Android
              : PushNotificationDeviceTypeEnum.Ios,
            deviceToken: expoToken,
          },
        },
      });
    }

    Notifications.dismissAllNotificationsAsync();
    Notifications.setBadgeCountAsync(0);
  }, [attachDeviceToUser]);

  return sendExpoToken;
};
